module.exports = __webpack_public_path__ + "static/media/redants1.16c9f54f.jpg";